import Cookies from 'js-cookie';

const app = {
  state: {
    theme: 'default',
    livenewsChannels: Cookies.get('livenewsChannels') || '[]'
  },
  mutations: {
    
  },
  actions: {

  }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js